// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"MobileNounWinEvent_iconWrapper__17_yv","switchIcon":"MobileNounWinEvent_switchIcon__UKYG_","bold":"MobileNounWinEvent_bold__2J-F1"};